module.exports = __webpack_public_path__ + "img/logo.png?aedea17d5295e3105e189bf04cc3e9fe";


//////////////////
// WEBPACK FOOTER
// ./app/assets/logo.png
// module id = 739
// module chunks = 40